// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3ILQZ","header":"PatientBlock_header__2tKWx","label":"PatientBlock_label__1456M","option":"PatientBlock_option__37Iwp"};